import { API_BASE } from './http';

/**
 * Повідомити сервер, що малюнок не відмалювався.
 *
 * НАВІЩО. `SafeSvg` на зламаній розмітці повертає `null`: дитина бачить
 * порожню рамку, гра йде далі, і ніде не лишається сліду. Саме ця тиша дала
 * попередній поломці з малюнками прожити стільки, скільки вона прожила —
 * 645 питань показували дітям сирий код, і помітив це випадково батько.
 *
 * Три властивості, без яких із цього була б шкода:
 *
 *  1. Один раз на питання за сеанс. Той самий зламаний малюнок може
 *     перемальовуватись десятки разів (ререндер, перехід назад, таймер), і
 *     без цієї памʼяті ми б слали шквал запитів заради одного факту.
 *  2. Мовчазно. Телеметрія не має права зламати гру: жодних кидків нагору,
 *     жодного очікування відповіді. Найгірше, що станеться, — не дізнаємось.
 *  3. `keepalive`. Малюнок часто ламається рівно перед тим, як дитина йде
 *     далі; без цього прапорця браузер обірвав би запит разом зі сторінкою.
 */

const reported = new Set<string>();

export type FigureField = 'passage' | 'choice';

export function reportFigureFailure(itemId: string | undefined, field: FigureField): void {
  if (!itemId) return;
  const key = `${itemId}|${field}`;
  if (reported.has(key)) return;
  reported.add(key);

  void fetch(`${API_BASE}/figure-failures`, {
    method: 'POST',
    credentials: 'include',
    keepalive: true,
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ itemId, field }),
  }).catch(() => {
    // Нема звʼязку — і нехай. Наступного разу спробуємо знову.
    reported.delete(key);
  });
}

/** Тільки для тестів: забути, про що вже повідомляли. */
export function resetReportedFigures(): void {
  reported.clear();
}
